export default __webpack_public_path__ + "static/media/gallery_05.9b955b9d.jpg";